import moment from "moment";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { LoadState } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";

export interface IAccountingPaymentBulkAccountsRecievableState {
  bulkPayment: {
    list: IPaymentBulkAccountsRecievable[];
    listLoading: LoadState;
    totalRecords: number;
    data: IPaymentBulkAccountsRecievable;
    loading: LoadState;
    error: string | null;
  };
}

export interface IPaymentBulkAccountsRecievable {
  accn_invoice_payment_accounts_receivable_id?: any;
  invoice_id: number | null;
  customerId?: any;
  payment_id: number | null;
  entry_type: string | null;
  payment_number: string | null;
  gl_accounts: string | null;
  invoice_payment_gl_account_name: string | null;
  date: string | null;
  batch_id: string | null;
  receipt_id: string | null;
  code: string | null;
  name: string | null;
  payment_for: string | null;
  policy_id: string | null;
  policy_number: string | null;
  default_tax_region: string | null;
  payment_type: string;
  payment_currency: string | null;
  payment_amount: string | null;
  service_fee: string | null;
  payment_method: string | null;
  bank: string | null;
  reference_info: string | null;
  status: string;
  file_upload: IFileUpload[] | null;
  invoice_details: IInvoiceBulkDetails[];
  total_paid: string | null;
  amount_excess: string | null;
  total_due: string | null;
  is_mannual_invoice: boolean;
  broker_code: string | null;

  payment_frequency: string | null;
  paid_to: string | null;
  vendor: string | null;
  cheque_id: string | null;
  agency_or_direct_bill: string | null;
  reconciled?: string | null;
  reconciled_date?: string | null;
}

export interface IInvoiceBulkDetails {
  key: string;
  customer_id: number | null;
  customer_policy_id: string | null;
  customer_name: string | null;
  policy_number: string | null;
  agency_or_direct_bill: string | null;
  date: string | null;
  payment_amount: string | null;
  invoice_id: string | null;
  fromCustomer: boolean;
  financed_by?: string | null;
}

export const initialAccountingPaymentBulkAccountsRecievableState: IAccountingPaymentBulkAccountsRecievableState =
  {
    bulkPayment: {
      list: [],
      totalRecords: 0,
      listLoading: LoadState.NotLoaded,
      data: {
      invoice_id: null,
      payment_id: null,
      payment_number: null,
      entry_type: null,
      gl_accounts: null,
      invoice_payment_gl_account_name: null,
      date: moment().format("YYYY-MM-DD"),
      batch_id: null,
      receipt_id: null,
      code: null,
      name: null,
      payment_for: null,
      policy_id: null,
      policy_number: null,
      default_tax_region: "ON",
      payment_type: "Refund",
      payment_currency: "CAD",
      payment_amount: null,
      service_fee: null,
      payment_method: null,
      bank: null,
      reference_info: null,
      agency_or_direct_bill: null,
      status: "ACTIVE",
      file_upload: null,
      invoice_details: [
        {
          key: getUniqueId(),
          customer_id: null,
          customer_policy_id: null,
          customer_name: null,
          policy_number: null,
          agency_or_direct_bill: null,
          invoice_id: null,
          date: null,
          payment_amount: null,
          fromCustomer: false,
          financed_by: null,
        },
      ],

      total_due: null,
      is_mannual_invoice: false,
      amount_excess: null,
      total_paid: null,
      broker_code: null,

      paid_to: "Customer",
      payment_frequency: null,
      vendor: null,
        cheque_id: null,
      },
      loading: LoadState.NotLoaded,
      error: null,
    },
  };
